var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 3.25c.966 0 1.75.784 1.75 1.75v14a1.75 1.75 0 1 1-3.5 0V5c0-.966.784-1.75 1.75-1.75M16 3.25c.966 0 1.75.784 1.75 1.75v14a1.75 1.75 0 1 1-3.5 0V5c0-.966.784-1.75 1.75-1.75"
  })));
};
export default SvgPause;